<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/weighing/record/page" getKey="rows" :columns="columns">
      <template #conditions> </template>

      <template #fujian="scope">
        <yi_upload :readOnly="true" :ids.sync="scope.row.uploadFiles" :limit="5"> </yi_upload>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_cast_management_soup_record_iqc_inspection_detail',
  props: {
    soupRecordId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      conditions: {
        sourceDocumentId: this.soupRecordId,
        businessType: '18'
      },
      columns: [
        {
          label: 'chengzhongshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'chengzhongleixing',
          prop: 'weighingType',
          type: 'dictionary',
          key: 'WEIGHING_TYPE'
        },
        {
          label: 'caozuoren',
          prop: 'operatorObject.nickname'
        },
        {
          label: 'chengzhongzhongliang',
          prop: 'weight'
        },
        {
          label: 'zhongliangdanwei',
          prop: 'weightUnit',
          type: 'dictionary',
          key: 'UNIT_CONVERSION_TYPE'
        },
        {
          label: 'shurufangshi',
          prop: 'inputMethod',
          type: 'dictionary',
          key: 'WEIGHING_INPUT_METHOD'
        },
        {
          label: 'fujian',
          prop: 'uploadFiles',
          type: 'slot',
          width: 280
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = this.utils.copy(this.conditions);
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 测量值转字符串
    toStr(array) {
      if (!array) {
        return '';
      }
      let str = '';
      for (let i = 0; i < array.length; i++) {
        const a = array[i];
        const s = this.$t('yangben') + `${i + 1}: ${a}`;
        if (i !== array.length - 1) {
          str += s + '<br />';
        } else {
          str += s;
        }
      }
      return str;
    }
  }
};
</script>
